import { provide, inject, reactive, App, readonly } from 'vue';
import {
  getLeftDrawerToggleListeners,
  ILeftDrawerState,
  ILeftDrawerStore,
  TSetLeftDrawerState,
  TToggleLeftDrawer
} from '@/store/contracts/leftDrawer';
import { impl } from '@/utils/impl';

const LeftDrawerStoreKey = Symbol('LeftDrawerStore');
let provided = false;

const createState = () => reactive(impl<ILeftDrawerState>({
  open: true
}));

function setLeftDrawerState (state: ILeftDrawerState): TSetLeftDrawerState {
  return (value) => {
    const toggled = value !== state.open;
    state.open = value;
    if (toggled) {
      const listeners = getLeftDrawerToggleListeners();
      Object.values(listeners).forEach(l => l(state.open));
    }
  };
}

function toggleLeftDrawer (state: ILeftDrawerState): TToggleLeftDrawer {
  return () => {
    setLeftDrawerState(state)(!state.open);
  };
}

export function provideStore (app?: App<Element>): void {
  if (!provided) {
    provided = true;
    if (app !== undefined) {
      app.provide(LeftDrawerStoreKey, createState());
    } else {
      provide(LeftDrawerStoreKey, createState());
    }
  }
}

export function useStore (): ILeftDrawerStore {
  const state = inject<ILeftDrawerState>(LeftDrawerStoreKey);
  if (state === undefined) {
    throw new Error('Using LeftDrawerStore before providing it!');
  }

  return {
    state: readonly(state),
    setLeftDrawerState: setLeftDrawerState(state),
    toggleLeftDrawer: toggleLeftDrawer(state)
  };
}
